import React, { useEffect, useState } from "react";
import Breadcrumbs from "components/Common/Breadcrumb";
import { MetaTags } from "react-meta-tags";
import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import SweetAlert from "react-bootstrap-sweetalert";
import BreadcrumbSub from "components/Common/BreadcrumbSub";
import { CreateBlog } from "./Create";
import { deleteBlog, getAllBlogsList } from "services/V2_APIs/blog.service";
import BlogsList from "./BlogsList";
import BlogsDetailsPage from "./BlogsDetailsPage";
import SuccessAlert from "components/Alerts/succes";
import ErrorAlert from "components/Alerts/error";
export const BlogsMainPage = () => {
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success_msg, setsuccess_msg] = useState(false);
  const [error_msg, seterror_msg] = useState(false);
  const [delete_modal, setDelete_modal] = useState(false);
  const [deleteId, setDeleteid] = useState(null);
  const [blogs, setBlogs] = useState([]);
  const [activeBlog, setActiveBlog] = useState({});
  // const [activeId, setActiveId] = useState();
  const [ActiveEditBlog, setActiveEditBlog] = useState();
  const [blogId, setBlogId] = useState("");
  console.log(blogs, "blogsblogs", activeBlog,blogId);
  const toggle = () => {
    if (modal) {
      setActiveEditBlog(null);
    }
    setModal(!modal);
  };

  useEffect(() => {
    getAllBlogs();
  }, []);
  const getAllBlogs = () => {
    setLoading(true);
    getAllBlogsList()
      .then(res => {
        const sortedBlogs = res?.data?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setBlogs(sortedBlogs);
        setLoading(false);
      })
      .catch(err => {
        console.log(err);
        setLoading(false);
      });
  };
  

  const handleActiveOrder = ele => {
    setActiveBlog(ele);
  };
  const SethandleActiveOrderEmpty =()=>{
    setActiveBlog({})
  }
  const handleActiveEdit = ele => {
    setActiveEditBlog(ele);
    toggle();
  };
  const handleActiveDelete = id => {
    console.log(id,"id")
    setDelete_modal(true);
    setBlogId(id?._id);
  };

  const stayHere = () => {
    setsuccess_msg(false);
    seterror_msg(false);
    setDelete_modal(false);
  };
  const leaveToList = () => {
    setsuccess_msg(false);
    seterror_msg(false);
    setDelete_modal(false);
  };
  const handleOnDelete = () => {
    deleteBlog(blogId)
      .then(res => {
        console.log(res);
        getAllBlogs();
        if (res?.data) {
          setDelete_modal(false);
          setsuccess_msg(true);
        }
      })
      .catch(err => {
        console.log(err);
        seterror_msg(true);
      });
  };
  const deletePopup = () => {
    return (
      <SweetAlert
        title="Are you sure ?"
        warning
        onConfirm={handleOnDelete}
        onCancel={stayHere}
        customButtons={
          <React.Fragment>
            <Button
              color="primary"
              className="w-md btn-sm mx-1"
              onClick={handleOnDelete}
            >
              Delete
            </Button>
            <Button
              color="light"
              className="w-md btn-sm mx-1"
              onClick={stayHere}
            >
              cancel
            </Button>
          </React.Fragment>
        }
      >
        You will not be able to recover this record
      </SweetAlert>
    );
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title></title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Blog" breadcrumbItem="Blog Page" />
          <BreadcrumbSub subtile="Blogs List" SubBreadcrumbItem="Blogs" />

          <div className="d-flex justify-content-end">
            <div className="">
              <Button
                type="button"
                color="primary"
                size="sm"
                className="ms-2 px-4"
                onClick={() => toggle()}
              >
                Create Blog
              </Button>
            </div>
          </div>
          <Row className="px-4 mt-3">
            <Col md="4">
              <Card>
                <BlogsList
                  blogs={blogs}
                  handleActiveOrder={handleActiveOrder}
                />
              </Card>
            </Col>
            <Col md="8" className="Order_details_page">
              <BlogsDetailsPage
                activeBlog={activeBlog}
                handleActiveEdit={handleActiveEdit}
                handleActiveDelete={handleActiveDelete}
              />
            </Col>
          </Row>
        </Container>
        <CreateBlog
          toggle={toggle}
          modal={modal}
          id={ActiveEditBlog}
          reload={getAllBlogs}
          handleActiveOrder={SethandleActiveOrderEmpty}
        />
      </div>
      {delete_modal ? deletePopup() : null}
      {success_msg ? (
        <SuccessAlert
          msg={"Successfully Blog Deleted"}
          leaveToList={leaveToList}
          stayHere={stayHere}
        />
      ) : null}
      {error_msg ? (
        <ErrorAlert
          msg={"error"}
          leaveToList={leaveToList}
          stayHere={stayHere}
        />
      ) : null}
    </React.Fragment>
  );
};
export default BlogsMainPage;
